import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ccs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const onAuthPage = ["/login", "/signup"].includes(window.location.pathname);
      if (!onAuthPage) {
        localStorage.removeItem("ccs_token");
        localStorage.removeItem("ccs_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
